import { Badge, Button, InputNumber, Select } from 'antd';
import { formatNumberWithCommas } from '../../utils/Utils';

/**
 * Main order table columns
 */
export const getOrderColumns = (handleFinishedCourse, authState) => [
    {
        title: 'Order ID',
        dataIndex: 'id',
        key: 'id',
        width: '5%',
        align: "center",
    },
    {
        title: 'ชื่อ',
        dataIndex: 'item_name',
        key: 'item_name',
        align: "left"
    },
    {
        title: 'จำนวนครั้ง',
        dataIndex: 'item_times',
        key: 'item_times',
        width: '3.5%',
        align: "center"
    },
    {
        title: 'คงเหลือ',
        dataIndex: 'item_remain',
        key: 'item_remain',
        width: '3.5%',
        align: "center"
    },
    {
        title: 'ราคา',
        dataIndex: 'item_totalprice',
        key: 'item_totalprice',
        width: '5%',
        align: "center",
        render: (item_totalprice) => {
            return formatNumberWithCommas(item_totalprice)
        }
    },
    {
        title: 'ส่วนลด',
        dataIndex: 'discount_value',
        key: 'discount_value',
        width: '5%',
        align: "center",
        render: (discount_value) => {
            return formatNumberWithCommas(discount_value)
        }
    },
    {
        title: 'ราคาที่จ่ายไปเเล้ว',
        dataIndex: 'item_paid',
        key: 'item_paid',
        width: '5%',
        align: "center",
        render: (item_paid) => {
            return formatNumberWithCommas(item_paid)
        }
    },
    {
        title: 'รายรับจริง',
        dataIndex: 'relize_revenue',
        key: 'relize_revenue',
        align: "center",
        width: '5%',
        render: (relize_revenue) => {
            return formatNumberWithCommas(relize_revenue)
        }
    },
    {
        title: 'รหัสผู้แนะนำ',
        dataIndex: 'inviter_id',
        key: 'inviter_id',
        align: "center",
        width: '7%',
        render: (inviter_id) => {
            if (inviter_id === -1) {
                return <span>พาร์ทไทม์</span>;
            } else if (inviter_id === 0) {
                return <span>ไม่มี</span>;
            }
            return inviter_id;
        },
    },
    {
        title: 'ประเภท',
        dataIndex: 'type',
        key: 'type',
        align: "center",
        width: '7%',
        render: (type) => {
            if (type === 1) {
                return <span>บริการ</span>;
            } else if (type === 2) {
                return <span>คอร์สต์</span>;
            } else if (type === 3) {
                return <span>โปรดักส์</span>;
            }
            return null;
        },
    },
    {
        title: 'สถานะ',
        dataIndex: 'item_status',
        key: 'item_status',
        align: "center",
        width: '15%',
        render: (item_status) => {
            if (item_status === 1) {
                return <Badge status="success" text="รายการเสร็จสิ้น" />
            }
            else if (item_status === 0) {
                return <Badge status="processing" text="อยู่ระหว่างดำเนินการ" />
            }
            else if (item_status === 2) {
                return <Badge status="warning" text="ชำระเสร็จสิ้น" />
            }
        }
    },
    {
        title: 'จัดการ',
        dataIndex: 'operation',
        align: 'center',
        width: '12%',
        render: (_, record) => {
            const finished = record.item_status === 1;
            return (
                <div className='flex gap-x-1 justify-center'>
                    <Button className={`border-[1px] border-black  rounded-md px-1  ${finished ? 'bg-[#6674c4] hover:translate-y-[-3px] duration-100 text-[#ffffff]' : 'bg-grey text-[#131212] '}`} disabled={!finished || authState.department_id === 0} onClick={() => { handleFinishedCourse(record) }}>เสร็จสิ้น</Button>
                </div>
            )
        }
        ,
    },
];

/**
 * Order modal table columns
 */
export const getOrderModalColumns = (handleDelete, cart) => [
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id'
    },
    {
        title: 'ชื่อ',
        dataIndex: 'name',
        key: 'name'
    },
    {
        title: 'จำนวนครั้ง',
        dataIndex: 'times',
        key: 'times',
        editable: true
    },
    {
        title: 'ราคาต่อหน่วย',
        dataIndex: 'price',
        key: 'price',
        render: (price) => {
            return formatNumberWithCommas(price)
        }
    },
    {
        title: 'ราคารวม',
        dataIndex: 'totalPrice',
        key: 'totalPrice',
        render: (totalPrice) => {
            return formatNumberWithCommas(totalPrice)
        }
    },
    {
        title: 'ส่วนลด',
        dataIndex: 'discount',
        key: 'discount',
        render: (_, record) => {
            return (
                <span>{formatNumberWithCommas((record.discount / 100 * record.totalPrice).toFixed(2))}</span>
            )
        }
    },
    {
        title: 'รหัสผู้แนะนำ',
        dataIndex: 'inviter_id',
        key: 'inviter_id'
    },
    {
        title: 'จ่ายราคา',
        dataIndex: 'price_to_paid',
        key: 'price_to_paid',
        render: (price_to_paid) => {
            return formatNumberWithCommas(price_to_paid)
        }
    },
    {
        title: 'จำนวนที่ใช้',
        dataIndex: 'times_to_use',
        key: 'times_to_use',
    },
    {
        title: 'จำนวนที่ใช้',
        dataIndex: 'times_to_use',
        key: 'times_to_use',
    },
    {
        title: 'ตัวเลือกการใช้บริการ',
        dataIndex: 'use_options',
        key: 'use_options',
        render: (use_options) => {
            if (use_options === 0) {
                return <span>ไม่ใช้</span>;
            } else if (use_options === 1) {
                return <span>ใช้</span>;
            }
            return null;
        },
    },
    {
        title: 'ประเภท',
        dataIndex: 'type',
        key: 'type',
        render: (type) => {
            if (type === 1) {
                return <span>บริการ</span>;
            } else if (type === 2) {
                return <span>คอร์สต์</span>;
            }
            return null;
        },
    },
    {
        title: 'จัดการ',
        dataIndex: 'operation',
        render: (_, record) =>
            cart.length >= 1 ? (
                <Button onClick={() => handleDelete(record.id)}>Delete</Button>
            ) : null,
    },
];

/**
 * Billing modal table columns
 */
export const getBillingColumns = (selectedRow, setSelectedRow, employeeoption, employeeoptionWithFilter, isEmployeeUnlock) => [
    {
        title: 'Order ID',
        dataIndex: 'id',
        key: 'id',
    },
    {
        title: 'ชื่อ',
        dataIndex: 'item_name',
        key: 'item_name',
    },
    {
        title: 'จำนวนครั้ง',
        dataIndex: 'item_times',
        key: 'item_times',
    },
    {
        title: 'คงเหลือ',
        dataIndex: 'item_remain',
        key: 'item_remain',
    },
    {
        title: 'ราคารวม',
        dataIndex: 'item_totalprice',
        key: 'item_totalprice',
        render: (item_totalprice) => {
            return formatNumberWithCommas(item_totalprice)
        }
    },
    {
        title: 'ราคาคงเหลือ',
        dataIndex: 'remain_price',
        key: 'remain_price',
        render: (_, record) => {
            return formatNumberWithCommas(record.item_totalprice - record.item_paid);
        },
    },
    {
        title: 'ราคาที่จะจ่าย',
        dataIndex: 'price_to_paid',
        key: 'price_to_paid',
        editable: true,
        render: (price_to_paid) => {
            return formatNumberWithCommas(price_to_paid)
        }
    },
    {
        title: 'จำนวนครั้งที่ใช้',
        dataIndex: 'times_to_use',
        key: 'times_to_use',
        editable: true,
    },
    {
        title: 'ประเภท',
        dataIndex: 'type',
        key: 'type',
    },
    {
        title: 'จำนวนค่ามือ',
        dataIndex: 'handfee_times',
        key: 'handfee_times',
        render: (_, record) => (
            <InputNumber onChange={
                (value) => {
                    const newData = selectedRow.map((item) =>
                        item.id === record.id ? { ...item, handfee_times: value } : item
                    );
                    setSelectedRow(newData);
                }}
                max={100}
                min={0}
                defaultValue={0}
            >
            </InputNumber>
        )
    },
    {
        title: 'พนักงาน',
        dataIndex: 'employee_id',
        key: 'employee_id',
        render: (_, record) => (
            <Select
                mode='multiple'
                showSearch
                placeholder="กรุณาเลือกผู้รักษา"
                value={record.employee_id}
                onChange={(value) => {
                    if (value?.length > 3) {
                        value.pop();
                        return
                    }
                    const newData = selectedRow.map((item) =>
                        item.id === record.id ? { ...item, employee_id: value } : item
                    );
                    setSelectedRow(newData);
                }}
                style={{ width: '20rem' }}
                filterOption={(input, option) =>
                    option.value.toString().toLowerCase().includes(input.toLowerCase()) ||
                    option.children.toLowerCase().includes(input.toLowerCase())
                }
            >
                {(isEmployeeUnlock ? employeeoption : employeeoptionWithFilter).map((employee) => (
                    <Select.Option key={employee.value} value={employee.value}>
                        {employee.label}
                    </Select.Option>
                ))}
            </Select>
        ),
    },
];

/**
 * Expanded row (bill items) table columns
 */
export const getExpandedRowColumns = (handleDeleteCourse, authState, filteredBillItems) => [
    {
        title: 'ลำดับ',
        dataIndex: 'index',
        key: 'index',
        width: '5%',
        render: (text, record, index) => index + 1,
    },
    {
        title: 'วันที่',
        dataIndex: 'createdAt',
        key: 'createdAt',
        width: '30%'
    },
    {
        title: 'จำนวนที่ใช้',
        dataIndex: 'times_used',
        key: 'times_used',
        width: '10%'
    },
    {
        title: 'ราคาที่จ่าย',
        dataIndex: 'price_to_paid',
        key: 'price_to_paid',
        render: (price_to_paid) => {
            return formatNumberWithCommas(price_to_paid)
        }
    },
    {
        title: 'รายรับจริง',
        dataIndex: 'relize_revenue',
        key: 'relize_revenue',
        width: '10%',
        render: (relize_revenue) => {
            return formatNumberWithCommas(relize_revenue)
        }
    },
    {
        title: 'ราคาคงเหลือ',
        dataIndex: 'remain_price',
        key: 'remain_price',
        render: (remain_price) => {
            return formatNumberWithCommas(remain_price)
        }
    },
    {
        title: 'รหัสผู้ทำการรักษา',
        dataIndex: 'employee_list',
        key: 'employee_list',
        width: '10%',
        render(_, record, index) {
            if (record.employee_list?.length === 0) {
                return <span>ไม่มี</span>;
            }
            return record.employee_list?.map((employee, employeeIndex) => (
                <span key={employeeIndex}>
                    {employee === 0 ? "-" : employee === -1 ? "-" : employee}
                    {employeeIndex !== record.employee_list.length - 1 && ','}
                </span>
            ));
        }
    },
    {
        title: 'จำนวนค่ามือ',
        dataIndex: 'handfee',
        key: 'handfee',
        width: '10%',
        render(_, record, index) {
            if (record.employee_list?.length === 0) {
                return <span>ไม่มี</span>;
            }
            return record.employee_list?.map((employee, employeeIndex) => (
                <span key={employeeIndex}>
                    {employee === 0 ? "-" : employee === -1 ? "-" : record.handfee}
                    {employeeIndex !== record.employee_list.length - 1 && ','}
                </span>
            ));
        }
    },
    {
        title: 'จัดการ',
        dataIndex: 'operation',
        key: 'operation',
        render(_, record, index) {
            const lastIndex = index === (filteredBillItems.length - 1)
            return (
                <Button onClick={() => { handleDeleteCourse(record, index) }} disabled={!lastIndex || authState.department_id === 0}>ลบ</Button>
            )
        }
    },
];
